import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app'

import { getQueryParams } from './utils'

const queryParams = getQueryParams()

ReactDOM.render(
  <React.StrictMode>
    <App formId={queryParams.formId || 'jKG3qVVN'} />
  </React.StrictMode>,
  document.getElementById('root')
)
